<template>
  <div class="studies">
    <div class="studies__table-wrapper">
      <custom-table
        :title="title"
        :tableData="dataArray"
        :pagesCount="pagesCount"
        :paginationMethod="'fetchUsers'"
        class="studies__table"
        :extLoading="loading"
      >
        <template slot="headerData">
          <div class="table__flex-header">
            <div class="table__title">{{ title }}</div>
          </div>
        </template>
        <template slot="thead">
          <th>ID</th>
          <th>Username</th>
          <th>First name</th>
          <th>Last name</th>
          <th>E-mail</th>
        </template>
        <template slot-scope="{ row }">
          <td>{{ row.id }}</td>
          <td>{{ row.username }}</td>
          <td>{{ row.first_name }}</td>
          <td>{{ row.last_name }}</td>
          <td>{{ row.email }}</td>
          <td>
            <drop-down tag="div" title="Options">
              <a class="dropdown-item" @click="showDatapoints(row.id)"
                >Datapoints</a
              >
              <a class="dropdown-item" @click="uploadLink(row.token)"
                >Upload link</a
              >
              <a class="dropdown-item" @click="modalToggle(row.id)">Delete</a>
            </drop-down>
          </td>
        </template>
      </custom-table>
    </div>

    <new-users class="users__form"></new-users>
  </div>
</template>

<script>
import { apiError } from "@/util/ErrorMessage.js";
import CustomTable from "../../customReusableComponents/CustomTable";
import NewUsers from "./NewUsers/NewUsers";

export default {
  components: { CustomTable, NewUsers },
  data() {
    return {
      title: "Users",
      showModal: false,
      loading: false
    };
  },
  computed: {
    pagesCount() {
      const entries = this.$store.getters.getUsersQuantity;
      return Math.ceil(entries / 5);
    },
    dataArray() {
      const entries = this.$store.getters.users;
      // entries.map(item => {
      //   item.created_at = this.convertData(item.created_at);
      // });
      return entries;
    }
  },
  methods: {
    convertData(data) {
      return new Date(data)
        .toDateString()
        .split(" ")
        .slice(1, 4)
        .join(" ");
    },
    modalToggle(id) {
      this.$store.dispatch("toggleModal");
      this.$store.dispatch("sendUserIdToModal", id);
    },
    uploadLink(token) {
      window.open("https://uploader.saliency.ai/" + token);
    },
    showDatapoints(id) {
      this.$store.dispatch("setStudiesFilter", "userid=" + id);
      this.$router.push({ path: "datapoints" });
    }
  },
  async created() {
    this.loading = true;

    try {
      await this.$store.dispatch("fetchUsers", 1);
    } catch (error) {
      apiError(error, this);
    }

    this.loading = false;
  }
};
</script>
<style lang="scss">
.studies {
  display: flex;
  justify-content: space-between;

  @media only screen and (min-width: 320px) and (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }

  &__table-wrapper {
    width: 60%;
    overflow: auto;

    @media only screen and (min-width: 320px) and (max-width: 768px) {
      width: 100%;
      margin-bottom: 10px;
    }
  }

  &__table {
    width: 100%;
  }

  &__form {
    width: 35%;

    @media only screen and (min-width: 320px) and (max-width: 480px) {
      width: 100%;
    }
  }
}
</style>
